module.exports = __webpack_public_path__ + "assets/img/8bb4-pk.svg";